'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiBeaker = function TiBeaker(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.4 28l-4.4-16.3h2c0.9 0 1.7-0.8 1.7-1.7s-0.8-1.7-1.7-1.7h-20c-0.9 0-1.7 0.8-1.7 1.7s0.8 1.7 1.7 1.7h1.9c0 0.3-0.1 0.6-0.2 1.1l-4.1 15.2c-0.4 1.4-0.1 2.7 0.6 3.7 0.8 1.1 2.1 1.6 3.5 1.6h16.6c1.4 0 2.7-0.5 3.5-1.6 0.7-1 1-2.3 0.6-3.7z m-7.8-16.3l2.2 8.3c0 0-0.1 0-0.1 0h-13.4c0 0-0.1 0-0.1 0l1.7-6.3c0.1-0.6 0.3-1.3 0.3-2h9.4z m4.5 18c-0.1 0.2-0.4 0.3-0.8 0.3h-16.6c-0.4 0-0.7-0.1-0.8-0.3-0.2-0.2-0.2-0.5-0.1-0.8l2-7.4c0.2 0.1 0.3 0.2 0.5 0.2h13.4c0.2 0 0.3-0.1 0.5-0.2l2 7.4c0.1 0.3 0.1 0.6-0.1 0.8z' })
        )
    );
};

exports.default = TiBeaker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/beaker.js
// module id = 1986
// module chunks = 0